import React, { useState, useEffect, useRef, useContext } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { Row, Col, Form, Checkbox, Table, Input, Tooltip, Space } from 'antd';
import {
  theme,
  CardAnt,
  ButtonAnt,
  InputComponent,
  SelectComponent,
  TableComponent,
} from '@pfmam/pfmam';
import { Container, Box } from '../../styles/globalStyle';
import { CaretDownOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import NoDataFound from '../../common/components/noDataFound';
import phoneFormatter from 'phone-formatter';
import { MaskedInput } from 'antd-mask-input';
import { GetContactsAcctPortPermissions } from '../../actions/actions';
import { InfoCircleOutlined } from '@ant-design/icons';


const ButtonWrapper = styled(Space)`
  justify-content: flex-end;
  width: 100%;
  min-width: 100%;
  .primary {
    width: 160px;
  }
  ${(props) =>
    props.spacing &&
    css`
      margin-top: 48px;
    `}
`;
const OverrideStyle = createGlobalStyle`
  .ant-form-item-control-input-content {
    & > span {
      width: 100%;
    }
    .primary.ant-select-single:not(.ant-select-customize-input) {
      .ant-select-selector {
        height: 52px;
        width: 100%;
        background: ${theme.colors.white};
        color: ${theme.colors.black_secondary};
        border: 1px solid ${theme.colors.grey};
        padding: 14px 20px;
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          line-height: 20px;
        }
        .ant-select-selection-search-input {
          height: 100%;
        }
      }
      .ant-select-arrow {
        font-size: ${theme.font_size.size_l};
        margin-top: 0;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
      &.ant-select-focused {
        .ant-select-selector {
          box-shadow: ${theme.shadows.input_focus};
          border-color: ${theme.colors.blue_primay};
        }
          .ant-select-arrow {
          color: ${theme.colors.black_secondary};
        }
      } 
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) => props.linkTextColor};
    border-color: ${(props) => props.linkTextColor};
  }
  
  .form-select-dropdown {
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      .ant-select-item {
        &.ant-select-item-group {
          color: ${theme.colors.grey_tertiary};
          min-height: 16px;
          line-height: 16px;
          padding: 6px 12px;
          &:hover {
            background: none;
          }
        }
      }
      .ant-select-item-option-selected,
      .ant-select-item-option-active {
        &:not(.ant-select-item-option-disabled) {
          background: ${theme.colors.white};
          font-weight: normal;
        }
      }
      .ant-select-item {
        min-height: 40px;
        line-height: 24px;
        padding: 8px 12px;
        font-size: ${theme.font_size.size_xl};
        color: ${theme.colors.black_secondary};
        font-family: 'Inter';
        &:hover {
        background: ${theme.colors.light_grey};
        font-family: 'Inter';
      }
    }
  }
`;

const TableWrapper = styled.div`
  .ant-table-title {
    padding: 0 !important;
  }
  .table-primary .ant-table-thead > tr > th {
    font-family: 'Inter';
    font-weight: bold;
    text-align: center;
    border: 1px solid ${theme.colors.grey};
  }
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${theme.colors.transparent};
  }
  .ant-table-tbody > tr > td:not(:first-child) {
    text-align: center;
  }

  .ant-table-tbody > tr > td {
        border: 1px solid ${theme.colors.grey};

  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
   /* border-color: #1890ff; */
   border-color: ${(props) => props.linkTextColor} !important;
  }

  .ant-table.ant-table-middle
    .ant-table-tbody
    .ant-table-wrapper:only-child
    .ant-table {
    margin: -19px -16px;
  }
 
  
  td.ant-table-column-sort {
    background: ${theme.colors.white};
  }
  .ant-table-column-sorters {
    justify-content: flex-start;
    .ant-table-column-title {
      flex: 0 0 auto;
    }
    .ant-table-column-sorter-inner .anticon {
      color: ${theme.colors.grey_stone};
    }
    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
      color: ${theme.colors.black_sorted};
    }
  }
  .ant-table-tbody {
    & > tr {
      & > td {
        &.right-aligned-cell {
          padding-right: 32px;
        }
      }
    
      .ant-table-row-expand-icon {
        line-height: 32px;
        &:focus,
        &:hover {
          color: ${theme.colors.blue_primay};
          border-color: ${theme.colors.blue_primay};
        }
      }
      cursor: pointer;
    }
    .ant-table-tbody,
    .ant-table-expanded-row {
      .ant-table-row {
        cursor: default;
      }
    }
  }
  .link {
    &:hover {
      opacity: 0.6;
    }
    &:focus,
    &:active {
      opacity: 1;
    }
  }
`;

const Wrapper = styled.div`
  
`;

const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
  }
`;

const OverrideRemoveAccessButtonAnt = styled(ButtonAnt)`
  &&& {
    background: red;
    color: white;
    font-size: 14px;
    height:42px;
    padding-top: 5px;
    padding-bottom : 5px;
  }
`;


const RenderCreateACHAccountPermissionForm = (props) => {
  const { accountPermisionsDataSource, setAccountPermissionsDataSource, OnAccountsPermissionsOkClick, OnAccountsPermissionsCancelClick, formDisabled, setIsTouched } = props;
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);

  const columns = [
    {
      title: 'Account',
      dataIndex: 'DisplayName',
    },
    {
      title: 
      (
        <>
        <span>Link</span>
        <br></br> 
        <Checkbox
          style={{ marginTop: '5px' }}
          onChange={(e) => handleSelectAllChange(e)}
          checked={accountPermisionsDataSource.every((item) => item.HasAccess)}
          indeterminate={
            accountPermisionsDataSource.some((item) => item.HasAccess) &&
            !accountPermisionsDataSource.every((item) => item.HasAccess)
          }
          disabled={formDisabled} 
        >
        </Checkbox>
        </>
      ),
      dataIndex: 'HasAccess',
      editable: true,
      render: (_, record) => (
        <Checkbox disabled={formDisabled} checked={record.HasAccess} onChange={(e) => handleCheckboxChange(e, record)} />
      ),
    },
  ];

  const handleCheckboxChange = (e, row) => {
    setIsTouched(true);
    const newData = [...accountPermisionsDataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    if (index > -1) {

      const item = newData[index];
      newData[index] = { ...item, HasAccess: e.target.checked ? 1 : 0 }
      setAccountPermissionsDataSource(newData);
    }
  };

  const handleSelectAllChange = (e) => {
    setIsTouched(true);
    const newData = accountPermisionsDataSource.map((item, index) => {
        return {
          ...item,
          HasAccess: e.target.checked ? 1 : 0,
        };
    });
    setAccountPermissionsDataSource(newData);
  };

  const RemoveAllAccess = () => {
    setIsTouched(true);
    var data = accountPermisionsDataSource.map(items => ({
      ...items,
      HasAccess: 0
    }));
    setAccountPermissionsDataSource(data);
  };



  return (
    <>
      <Box display="flex" justifycontent="flex-end">
        <OverrideRemoveAccessButtonAnt
          hidden={accountPermisionsDataSource?.length > 0 ? false : true}
          type="secondary"
          label="Remove All Accounts"
          onClick={() => RemoveAllAccess()}
          disabled={formDisabled}
        />
      </Box>
      <br></br>
      <TableWrapper linkTextColor={primary_color}>
        {/* <Box display="flex" alignitems="center"> */}
        <Table
          className="table-primary"
          dataSource={accountPermisionsDataSource}
          columns={columns}
          pagination={false}
          locale={{
            emptyText: <NoDataFound text="No Accounts found" padding="12px 0" />,
          }}
        />
        {/* </Box> */}
      </TableWrapper>
      <br></br>

      {/* <Box display="flex" justifycontent="flex-end"> */}
      <ButtonWrapper size={12} spacing>
        <ButtonAnt
          label="Cancel"
          type="secondary"
          htmlType="button"
          onClick={() => OnAccountsPermissionsCancelClick()}
        />
        <OverrideButtonAnt
          type="secondary"
          label="Confirm"
          onClick={() => OnAccountsPermissionsOkClick()}
          linkTextColor={primary_color}
          hidden={accountPermisionsDataSource?.length > 0 ? false : true}
        />
      </ButtonWrapper>

      {/* </Box> */}
    </>
  );
};


const CreateACHInstructionsAccountPermissionsComponent = (props) => {
  const { accountPermisionsDataSource, setAccountPermissionsDataSource, OnAccountsPermissionsOkClick, OnAccountsPermissionsCancelClick, formDisabled, setIsTouched } = props;
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  return (
    <Wrapper>
      <OverrideStyle linkTextColor={primary_color} />
      <Container>
        <CardAnt
          cardContent={
            <RenderCreateACHAccountPermissionForm
              accountPermisionsDataSource={accountPermisionsDataSource}
              setAccountPermissionsDataSource={setAccountPermissionsDataSource}
              OnAccountsPermissionsOkClick={OnAccountsPermissionsOkClick}
              OnAccountsPermissionsCancelClick={OnAccountsPermissionsCancelClick}
              formDisabled={formDisabled}
              setIsTouched={setIsTouched}
            />}
          className="profile-card basic-card"
          title=
          {
            <div>
              <span>Accounts</span>
              <br/>
              <p style={{color: "gray", fontStyle: "italic", fontSize: "14px", lineHeight: "20px", whiteSpace: "normal" }}>Select account(s) in which to link instructions.</p>
            </div>
          }
        />
      </Container>
    </Wrapper>
  );
};

export default CreateACHInstructionsAccountPermissionsComponent;